import PropTypes from 'prop-types';
import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';
const IconArrowSmallBack = (props) => {
  const { color } = props;
  const colorCode = colorLookup(color) ?? colorLookup('blue');

  return (
    <SVG width="13" height="9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m8.248,0.165c-0.23,0.225 -0.23,0.597 -0.004,0.827l2.73,2.736l-10.394,0a0.58,0.58 0 1 0 0,1.168l10.4,0l-2.74,2.734a0.59,0.59 0 0 0 0.004,0.827a0.58,0.58 0 0 0 0.822,-0.004l3.702,-3.73c0.05,-0.054 0.1,-0.112 0.12,-0.184a0.56,0.56 0 0 0 0.045,-0.225c0,-0.153 -0.058,-0.296 -0.166,-0.41l-3.702,-3.724c-0.22,-0.234 -0.588,-0.238 -0.818,-0.013l0.001,-0.002z"
        fill={colorCode}
        transform="rotate(-180 6.46431 4.31354)"
      />
    </SVG>
  );
};
IconArrowSmallBack.propTypes = {
  color: PropTypes.string,
};
export { IconArrowSmallBack as default, IconArrowSmallBack };
